import styled from 'styled-components'

export const Title = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 20px;
  padding: 8px 0 8px 0;
`

export const Logo = styled.img`
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin: 21px 0 12px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    width: 140px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    width: 120px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    width: 100px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    width: 90px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    width: 80px;
  }
`

export const ReturnButton = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  left: 10%;

  width: 20px;
  height: 20px;

  :hover {
    background-color: #edebeb;
    cursor: pointer;
  }
`
export const MainText = styled.h1`
  position: absolute;
  left: 20%;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 16px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 14px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 14px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 11px;
  }
`
